<template>
  <div style="background-color: #f5f5f5; height: 100%">
    <!-- 内容 -->
    <div class="essay">
      <div>
        <!-- 轮播图 -->
        <van-swipe :autoplay="3000" @change="onChange" style="height: 376.5px">
          <van-swipe-item
            v-for="item in ImgsList"
            :key="item + 'aa'"
            @click="showImagePreview(index)"
            @change="onChangeImg"
          >
            <img
              :src="item"
              style="width: 100%; height: 375.5px; object-fit: cover"
            />
          </van-swipe-item>
          <template #indicator>
            <div class="custom-indicator">
              <span style="font-size: 14px">{{ count + 1 }}</span>
              <span style="font-size: 10px">/{{ ImgsList.length }}</span>
            </div>
          </template>
        </van-swipe>
        <!-- 预览轮播图 -->
        <van-image-preview
          v-model="ImagePreviewShow"
          :images="ImgsList"
          :start-position="this.current"
          @change="onChangeImagePreview"
          @close="closeImagePreview"
        >
        </van-image-preview>
        <!-- 商品标题 -->
        <div class="middle">
          <div class="flexClass">
            <div class="price">
              <span style="font-size: 12px">¥</span
              >{{ details.integral || details.price
              }}<span style="font-size: 10px">起</span>
              <!-- <span
                style="font-size: 28rpx; color: #999999"
                v-if="details.integral"
              >
                /{{ details.integral }}积分</span
              > -->
            </div>
            <div class="tips">距你大约6km</div>
          </div>
          <div class="title van-multi-ellipsis--l2">
            {{ details.goodsName }}
          </div>
          <div class="flexClass">
            <div class="tips" style="color: #999">
              已售{{ details.stockNum }}
            </div>
            <div class="tips" style="color: #999">
              剩余{{ details.stockNum }}
            </div>
          </div>
        </div>

        <!-- 店铺卡片 -->
        <div
          class="middle"
          style="margin-top: 12px; display: flex; align-items: center"
        >
          <img
            :src="this.storeImg"
            alt=""
            style="
              width: 60px;
              height: 63px;
              display: block;
              margin-right: 9px;
              object-fit: cover;
            "
          />
          <div class="van-multi-ellipsis--l2 title" style="flex: 1">
            {{ this.storeName }}
          </div>
          <button
            class="shop"
            @click="gotoUrl('/periphery/store/' + details.storeId)"
          >
            进店逛逛
          </button>
        </div>

        <van-tabs
          @click="onClickOnlyOne"
          color="#FEDE00"
          title-active-color="#1E1E1E"
          style="margin-top: 12px"
        >
          <van-tab
            v-for="item in typeList"
            :key="item.Coding"
            :name="item.Coding"
            :title="item.Name"
          >
          </van-tab>
        </van-tabs>
        <div class="middle" style="padding: 6px 12px">
          <!-- 商品详情 -->
          <div
            class="goodsXq"
            v-if="showDetails"
            v-html="details.goodsContent"
          ></div>
          <!-- 商品评价 -->
          <div v-if="showPingJia">
            <van-list
              v-model="loading"
              offset="2"
              :finished="finished"
              finished-text="没有更多评价了 ~"
              @load="onLoad"
              :immediate-check="false"
            >
              <div class="desc">
                <div
                  v-for="(item, index) in evaluateList"
                  :key="index"
                  class="evaluateListBox"
                >
                  <div style="display: flex; align-items: center">
                    <div class="evaluateListLeft">
                      <img :src="item.headImgUrl" />
                      <span>{{ item.nickName }}</span>
                    </div>
                    <div class="km" style="color: #999999">
                      {{ item.createTime }}
                    </div>
                  </div>
                  <div
                    class="km"
                    style="
                      color: #999999;
                      margin-left: 45px;
                      margin-bottom: 6px;
                    "
                  >
                    {{ item.content }}
                  </div>
                  <div class="replyContent" v-if="item.replyContent">
                    店主回复：{{ item.replyContent }}
                  </div>
                </div>
                <!-- <div
                    v-if="evaluateList.length == 0"
                    class="finish"
                    style="padding: 10px"
                  >
                    暂无评价
                  </div> -->
              </div>
            </van-list>
          </div>
        </div>

        <van-tabs
          @click="onClickOnlyOne1"
          color="#FEDE00"
          title-active-color="#1E1E1E"
          style="margin-top: 12px"
        >
          <van-tab
            v-for="item in typeList1"
            :key="item.Coding"
            :name="item.Coding"
            :title="item.Name"
          >
          </van-tab>
        </van-tabs>

        <div class="middle" style="padding: 6px 12px">
          <!-- 人气推荐 -->
          <div class="goodsXq" v-if="showHot">
            <!-- v-model="loading"
                offset="10"
                @load="onLoad" -->
            <van-list
              class="vanList"
              :finished="finished1"
              finished-text="没有更多了 ~"
              :immediate-check="false"
            >
              <!-- 双排 -->
              <div class="Box">
                <div
                  @click="
                    gotoUrl(
                      '/periphery/goodsDetail/' + item.id + '/' + integral
                    )
                  "
                  class="li"
                  v-for="item in goodLists2"
                  :key="item.id"
                >
                  <img
                    alt=""
                    v-if="item.goodsImg != null && item.goodsImg != ''"
                    :src="item.goodsImg.split(',')[0]"
                  />
                  <img
                    v-else
                    src="http://alycommunity.anluoyun.cn/lc-lcx/2023/6/35e14c95-10b.png"
                  />
                  <div
                    style="
                      box-sizing: border-box;
                      padding: 6px 8px 5px 8px;
                      border-left: 1px solid #f0f0f0;
                      border-right: 1px solid #f0f0f0;
                      border-bottom: 1px solid #f0f0f0;
                      border-radius: 0 0 8px 8px;
                    "
                  >
                    <div class="tit van-ellipsis">
                      {{ item.goodsName }}
                    </div>
                    <div class="km" style="margin-top: 8px; margin-bottom: 3px">
                      {{ item.distance }}10km
                    </div>
                    <div
                      style="
                        display: flex;
                        justify-content: space-between;
                        align-items: center;
                      "
                    >
                      <div class="price" style="font-size: 19px">
                        <span style="font-size: 12px">¥</span>{{ item.integral
                        }}<span style="font-size: 11px">/元</span>
                      </div>
                      <div class="km" style="font-weight: 400">
                        库存{{ item.stockNum }}
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  @click="
                    gotoUrl(
                      '/periphery/goodsDetail/' + item.id + '/' + integral
                    )
                  "
                  class="li"
                  v-for="item in goodLists1"
                  :key="item.id"
                >
                  <img
                    alt=""
                    v-if="item.goodsImg != null && item.goodsImg != ''"
                    :src="item.goodsImg.split(',')[0]"
                  />
                  <img
                    v-else
                    src="http://alycommunity.anluoyun.cn/lc-lcx/2023/6/35e14c95-10b.png"
                  />
                  <div
                    style="
                      box-sizing: border-box;
                      padding: 6px 8px 5px 8px;
                      border-left: 1px solid #f0f0f0;
                      border-right: 1px solid #f0f0f0;
                      border-bottom: 1px solid #f0f0f0;
                      border-radius: 0 0 8px 8px;
                    "
                  >
                    <div class="tit van-ellipsis">
                      {{ item.goodsName }}
                    </div>
                    <div class="km" style="margin-top: 8px; margin-bottom: 3px">
                      {{ item.distance }}10km
                    </div>
                    <div
                      style="
                        display: flex;
                        justify-content: space-between;
                        align-items: center;
                      "
                    >
                      <div class="price" style="font-size: 19px">
                        <span style="font-size: 12px">¥</span>{{ item.integral
                        }}<span style="font-size: 11px">/元</span>
                      </div>
                      <div class="km" style="font-weight: 400">
                        库存{{ item.stockNum }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </van-list>
          </div>
        </div>
        <!-- 预订 -->
        <div class="fixed">
          <div
            class="ul"
            style="margin-right: 15px; margin-left: 10px; margin-top: 4px"
            @click="gotoUrl('/periphery/store/' + details.storeId)"
          >
            <img
              src="http://alycommunity.anluoyun.cn/lc-lcxms/2023/12/604ada16-9b4.png"
              mode=""
              style="width: 17px; height: 15px"
            />
            <!-- 灰色 店铺图片 -->
            <!-- http://alycommunity.anluoyun.cn/lc-lcxms/2023/12/b83a02b5-3c3.png -->
            <div class="dianpu">店铺</div>
          </div>
          <button class="duihuan" @click="submitPay">
            <span style="margin-right: 15px">¥{{ details.integral }}</span
            ><span>立即购买</span>
          </button>
        </div>
      </div>
    </div>
    <van-dialog
      @confirm="submit"
      v-model="show"
      title="商品数量"
      show-cancel-button
    >
      <van-stepper
        style="margin: 20px 0; text-align: center"
        v-model="saleNum"
      />
    </van-dialog>
  </div>
</template>
  
  <script>
import { Wx_GetHotelRoom } from "@/api/RealInfo";
import { listOrderComment, Wx_GetHotelRoomList } from "@/api/Hotel";
import config from "@/config";
import Vue from "vue";
import { Toast } from "vant";
import { Dialog } from "vant";
import { getUrl, getPlatform, getIntegral } from "@/utils/auth";
Vue.use(Toast);
export default {
  components: {
    [Dialog.Component.name]: Dialog.Component,
  },
  data() {
    return {
      integral: "",
      goodLists1: [],
      goodLists2: [],
      typeList: [
        {
          Coding: "1",
          Name: "商品详情",
        },
        {
          Coding: "2",
          Name: "商品评价",
        },
      ],
      typeList1: [
        {
          Coding: "1",
          Name: "人气推荐",
        },
      ],
      loading: false, //加载
      finished: false, //数据完全加载结束为 true
      finished1: true,
      evaluateList: [], // 评价列表
      saleNum: 1,
      Service: [],
      weekStart: "",
      weekEnd: "",
      show: false, // 时间
      open: false,
      details: {},
      count: "",
      count1: "",
      ImgsList: [],
      ImagePreviewShow: false,
      index: 0,
      current: 0,
      list: [],
      url: config.hostUrl,
      storeName: "",
      storeImg: "",
      showDetails: true,
      showHot: true,
      showPingJia: false,
      page: 1,
      listfrom: {
        platformId: getPlatform(),
        pageNum: 1,
        pageSize: 4,
      }, //查询传参
    };
  },
  created() {
    this.wxGetPromotion();
    this.getEvaluateList();
    this.getList();
    // console.log(this.$route.params.integral, "this.$route.params"); // 积分
    this.integral = getIntegral();
    console.log(this.$store.state.user.url, "url");
    // this.getHRoomTypeList();
  },
  methods: {
    // 下拉刷新
    onLoad() {
      console.log("到底啦");
      // this.list = [];
      this.page = this.page + 1;
      this.getEvaluateList();
    },
    getEvaluateList() {
      listOrderComment({
        goodsId: this.$route.params.id,
        platformId: getPlatform(),
        pageSize: 10,
        pageNum: this.page,
      }).then((res) => {
        if (res.data.code == 200) {
          console.log(res);
          let rows = res.data.data.list;
          this.evaluateList = this.evaluateList.concat(rows);
          this.loading = false;
          if (!res.data.data.hasNextPage) {
            // 加载结束 => 没有下一页
            console.log("结束");
            this.finished = true;
          } else {
            this.finished = false;
          }
        } else {
          this.finished = true;
        }
      });
    },
    // 获取店铺信息
    getStoreInfo(id) {
      var that = this;
      console.log(getUrl(), 111111111);
      const axios = require("axios");
      const apiUrl = getUrl() + "pointsMall/storeInfo";
      const params = { storeId: id };
      // 发起 GET 请求，并将参数作为查询字符串传递
      axios
        .get(apiUrl, { params })
        .then((response) => {
          // 处理接口返回的数据
          console.log(response.data);
          that.storeName = response.data.data.name;
          that.storeImg = response.data.data.logo;
        })
        .catch((error) => {
          // 处理错误
          console.error(error);
        });
    },
    //得到图片索引值
    onChangeImg(index) {
      this.index = index;
    },
    //显示预览图
    showImagePreview(index) {
      this.ImagePreviewShow = true;
      this.current = index;
    },
    onChangeImagePreview(index) {
      this.index = index;
    },
    //关闭预览图
    closeImagePreview(info) {
      this.current = info.index;
    },

    // tab栏切换
    onClickOnlyOne(name) {
      console.log(name);
      if (name == 1) {
        // 商品详情
        this.wxGetPromotion();
        this.showDetails = true;
        this.showPingJia = false;
      } else {
        this.page = 1;
        this.evaluateList = [];
        this.getEvaluateList();
        // 商品评价
        this.showDetails = false;
        this.showPingJia = true;
      }
      // this.listfrom.useTo = name;
      // this.getList();
    },
    // 获取分页列表
    getList(goodsName) {
      Wx_GetHotelRoomList(this.listfrom).then((res) => {
        if (res.data.code == 200) {
          // this.list = res.data.data.list;
          // this.finished = true;
          /**第二种 */
          let rows = res.data.data.list; //请求返回当页的列表
          // 加载状态结束
          this.list = this.list.concat(rows);
          this.loading = false;

          if (!res.data.data.hasNextPage) {
            // 加载结束 => 没有下一页
            console.log("结束");
            this.finished = true;
          } else {
            this.finished = false;
          }
          // if (this.list.length >= res.data.data.total) {
          //   console.log(111);
          //   this.finished = true;
          // }
        } else {
          this.finished = true;
        }
        console.log(this.list, "this.list");
        var jiArr = [];
        var ouArr = [];
        for (var i = 0; i < this.list.length; i++) {
          if (i % 2 == 0) {
            ouArr.push(this.list[i]);
          } else {
            jiArr.push(this.list[i]);
          }
        }
        console.log(jiArr, "奇数项");
        console.log(ouArr, "偶数项");
        this.goodLists1 = jiArr;
        this.goodLists2 = ouArr;
        // }
      });
    },
    onClickOnlyOne1(name) {
      console.log(name);
      if (name == 1) {
        // 人气推荐
        // this.wxGetPromotion();
        this.showHot = true;
      }
    },

    // 跳转
    gotoUrl(path) {
      if (window.__wxjs_environment === "miniprogram") {
        // 页面 不会重新加载
        window.wx.miniProgram.navigateTo({
          url: "../public/goto?path=" + path,
        });
      } else {
        // 页面会 重新加载(如:列表页 查看详情后会返回顶部)
        this.$router.push(path);
      }
    },
    // 立即兑换
    submitPay() {
      this.show = true;
    },

    // 提交
    submit() {
      console.log(this.saleNum);
      this.gotoUrl(
        "/periphery/settlement/" +
          this.details.storeId +
          "/" +
          this.storeName +
          "/" +
          this.saleNum +
          "/" +
          this.details.id +
          "/" +
          this.details.integral
      );
    },

    onChange(index) {
      this.count = index;
    },
    onChange1(index) {
      this.count1 = index;
    },
    wxGetPromotion() {
      Wx_GetHotelRoom(this.$route.params.id).then((res) => {
        this.getStoreInfo(res.data.data.storeId);
        this.details = res.data.data;
        // console.log(this.details);
        if (res.data.data.goodsImg != "" && res.data.data.goodsImg != null) {
          // console.log(123321);
          this.ImgsList = res.data.data.goodsImg.split(",");
        } else {
          this.ImgsList = [
            "http://alycommunity.anluoyun.cn/lc-lcx/2023/6/35e14c95-10b.png",
          ];
        }
      });
    },
    gotominiProgram(details) {
      // console.log(details);
      if (details.Coordinate == "" || details.Coordinate == null) {
        Toast.fail("暂无位置信息");
      } else {
        this.nameCc = {
          Navigation: "导航",
          Coordinate: details.Coordinate,
        };
        if (window.__wxjs_environment === "miniprogram") {
          window.wx.miniProgram.navigateTo({
            url: "../openminip/openminip?name=" + JSON.stringify(this.nameCc),
          });
        } else {
          alert("请在小程序中打开");
        }
      }
    },
  },
};
</script>
  
  <style scoped>
@font-face {
  font-family: "Date";
  src: url(../../assets/font/DIN-MEDIUM.OTF);
}
@font-face {
  font-family: "Price";
  src: url(../../assets/font/OPPOSANS-H.TTF);
}
.essay {
  width: 100%;
  margin: auto;
  padding-bottom: 65px;
  background: #f5f5f5;
}
.custom-indicator {
  position: absolute;
  right: 0px;
  bottom: 15px;
  padding: 2px 15px;
  font-size: 14px;
  font-family: PingFang SC;
  color: #ffffff;
  background: #00000033;
  border-radius: 15px 0px 0px 15px;
  text-align: center;
  line-height: 20px;
}
.custom-indicator1 {
  position: absolute;
  right: 0px;
  bottom: 15px;
  padding: 4px 15px;
  font-size: 14px;
  font-family: PingFang SC;
  color: #ffffff;
  background: #00000033;
  border-radius: 15px 0px 0px 15px;
  text-align: center;
  line-height: 20px;
}
.middle {
  width: 100%;
  margin: auto;
  background: #ffffff;
  box-sizing: border-box;
  padding: 15px 12px;
}

.price {
  font-size: 21px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #ff4d59;
}

.flexClass {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.tips {
  font-size: 12px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #6f6f6f;
}

.shop {
  width: 75px !important;
  height: 30px;
  line-height: 30px;
  background: #ff4d59;
  border-radius: 15px;
  padding: 0;
  font-size: 12px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #ffffff;
  border: none;
}
/deep/ .van-tab__text {
  z-index: 9;
  font-size: 18px;
  font-family: PingFang SC;
}

/deep/ .van-tabs__line {
  bottom: 30px;
  background: linear-gradient(88deg, #ffffff 0%, #f26f87 100%);
  border-radius: 2px;
  width: 69px;
  height: 4px;
}
.duihuan {
  background: #f26f87;
  border-radius: 22px;
  border: none;
  font-size: 13px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #ffffff;
  width: 85%;
  padding: 9px 0;
}

/* `1111111111111111111 */

.left {
  width: 41.6%;
  height: 76px;
  background: #f1fcfe;
  border-radius: 8px;
}
.right {
  position: relative;
  /* width: 56.5%; */
  width: 100%;
  height: 76px;
  background: #f1fcfe;
  border-radius: 8px;
  background-image: url(https://dximg.dexian.ren/lczhsq/map.png);
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #1e1e1e;
  text-align: left;
  line-height: 76px;
  box-sizing: border-box;
  padding-left: 20px;
}

.day {
  position: relative;
  box-sizing: border-box;
  padding: 10px;
  display: flex;
  align-items: center;
  margin-top: 10px;
  height: 35px;
  background: #f1fcfe;
  border-radius: 8px;
  font-size: 18px;
  font-family: Date;
  font-weight: 500;
  color: #1e1e1e;
}

.day1 {
  font-size: 12px;
  color: #666666;
  margin-left: 2px;
}

.differ {
  width: 41px;
  height: 16px;
  line-height: 16px;
  border: 1px solid #2dd6ea;
  border-radius: 8px;
  font-size: 11px;
  font-family: PingFang SC;
  font-weight: 500;
  text-align: center;
  color: #0dd3e8;
  margin: 0 12px;
}
/deep/ .van-calendar__confirm {
  height: 42px;
}
/deep/ .van-calendar__day--start,
/deep/ .van-calendar__day--end {
  color: #1e1e1e;
  background-color: #f8de4b;
}

/deep/ .van-calendar__day--middle::after {
  background-color: #f8de4b;
  opacity: 0.19;
}
/deep/ .van-calendar__day--middle {
  color: #1e1e1e;
}
/deep/ .van-button--danger {
  background: #fede00;
  border: 1px solid #fede00;
  color: #1e1e1e;
}

.roomType {
  margin: auto;
  margin-top: -24px;
  width: 90%;
  background: #ffffff;
  border-radius: 8px;
  box-sizing: border-box;
  padding: 12px 8px;
}

.roomName {
  font-size: 15px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #1e1e1e;
}
.des {
  font-size: 12px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #666666;
  margin-top: 7px;
  /* 超过1行 隐藏 */
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
}
.less {
  font-size: 11px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #ff7300;
}

.box {
  padding: 25px 0px 25px 21px;
  border-top: 0.5px solid #f0f0f0;
  /* border-bottom: 0.5px solid #f0f0f0; */
}
.bed {
  font-size: 12px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #1e1e1e;
  /* 超过1行 隐藏 */
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}
.card {
  width: 90%;
  margin: auto;
  background: #ffffff;
  border-radius: 8px;
  margin-top: 12px;
  box-sizing: border-box;
  padding: 21px 12px;
}
.zhuyao {
  font-size: 17px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #1e1e1e;
  text-align: center;
}

.li {
  /* justify-content: space-between;
  display: flex;
  flex-direction: column;
  align-items: center;
  font-size: 12px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #666666; */
}

/* 旧的样式 */
.biaoti {
  display: flex;
  justify-content: space-between;
}
.money {
  line-height: 33px;
  font-family: PingFang SC;
  font-weight: 550;
  color: #fe5b47;
  font-size: 18px;
}
.time {
  /* display: flex;
    justify-content: space-between; */
  padding: 5px 0;
  color: #0c0c0c;
  font-weight: bold;
  line-height: 30px;
}

.zhuyaoJd {
  font-size: 1.17em;
  font-weight: bold;
  margin-top: 1em;
  text-align: left;
  display: flex;
  justify-content: space-between;
}
.zhuyaoJd span {
  color: rgb(153, 153, 153);
  float: right;
  font-size: 12pt;
  font-weight: 300;
}
.waterfall {
  /* width: 95%; */
  margin: 10px auto;
  column-count: 2;
  column-gap: 0;
  column-width: auto;
}
.waterfall .list {
  margin: 0px 7px 10px 7px;
  break-inside: avoid;
  border-radius: 5px;
  background-color: #ffffff;
  box-shadow: 0px 5px 17px 1px rgba(0, 0, 0, 0.07);
}
.list img {
  width: 100%;
  border-top-right-radius: 5px;
  border-top-left-radius: 5px;
  /* height: 160px; */
  /* border-radius: 0px; */
}
.address {
  margin: 10px 0;
  font-weight: 550;
  font-size: 14px;
}
.shopType {
  background: #0646a7;
  color: #fff;
  padding: 3px 6px;
  border-radius: 8px;
  font-size: 12px;
  display: inline-block;
  margin-top: 10px;
  /* margin-left: 6px; */
}
.mapImg {
  background-image: url("http://xczxapi.zhsq.cloud//upload/images/2022/6/1ee98423-7b1.png");
  background-size: 100%;
  background-repeat: no-repeat;
}
.addressImage {
  width: 20px;
  height: 25px;
  margin-top: 8px;
}
.ditu {
  font-size: 14px;
  margin-top: 5px;
  color: #0c55b4;
  font-weight: 550;
}
.information .center {
  /* border-bottom: none; */
  /* border-bottom: 1px solid #f4f4f4; */
  border-radius: 5px;
  margin: 10px auto;
  width: 95%;
  padding: 5px;
  border-radius: 5px;
}
.centerTitle {
  font-size: 15px;
}
.vanCard {
  padding: 10px;
  background-color: white;
  border-radius: 8px;
  box-shadow: 0px 5px 17px 1px rgba(0, 0, 0, 0.07);
}
W .detailTitle {
  font-size: 18px;
  font-weight: 550;
}
.roomTypeDetailTitle {
  font-size: 12px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #000000;
}
.roomTypeDetailName {
  padding-left: 5px;
  font-size: 12px;
  font-family: PingFang SC;
  font-weight: normal;
  color: #1e1e1e;
}
.more {
  font-size: 13px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #06d7e4;
}
/deep/ .icon .van-icon {
  color: #06d7e4;
  font-size: 12px;
  margin-left: 3px;
}

/deep/ .van-submit-bar__bar {
  padding: 6px 16px;
}

/deep/ .van-submit-bar__button {
  background-color: #fe411b !important;
  border-color: #fe411b !important;
  font-size: 15px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #ffffff;
}
/deep/ .van-submit-bar__text {
  text-align: left;
}
/deep/ .van-submit-bar__price {
  font-family: Price;
}
/deep/ .van-submit-bar__price--integer {
  font-size: 22px;
}

.popup_box {
  height: 80%;
  background-color: #fff;
  padding-top: 48px;
  /* padding-bottom: 1.31rem; */
  overflow: hidden;
  position: relative;
}
.popup_top {
  width: 100%;
  box-sizing: border-box;
  padding: 0 12px;
  height: 48px;
  position: absolute;
  top: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.van-icon-cross {
  color: #181818;
}
.title {
  font-size: 18px;
  font-family: PingFang SC;
  color: #1e1e1e;
  margin: 6px 0 12px;
}
.popup_main {
  height: 100%;
  overflow-y: scroll;
  /* background-color: rgb(245, 223, 245); */
}

.fixed {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 55px;
  background-color: #fff;
  z-index: 100;
  text-align: center;
  box-shadow: 0px 2px 9px 0px rgba(117, 117, 117, 0.19);
  border-radius: 12px 12px 0px 0px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-sizing: border-box;
  padding: 10px 9px 13px;
}

.dianpu {
  font-size: 10px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #999999;
}
.tit1 {
  font-size: 14px;
  color: #666666;
  font-family: PingFang SC;
  font-weight: bold;
  margin-top: 10px;
}

.desc {
  font-size: 15px;
  font-family: PingFang SC;
  /* font-weight: 500; */
  color: #1e1e1e;
}

.evaluateListBox {
  margin: 7px 5px;
  border-bottom: 1px solid #f5f5f5;
}

.evaluateListLeft {
  width: 60%;
}

.evaluateListLeft img {
  width: 35px;
  height: 35px;
  border-radius: 35px;
  margin-right: 10px;
  vertical-align: middle;
}

.replyContent {
  background-color: #fafafa;
  margin: 5px 0 10px 45px;
  padding: 5px;
  font-size: 13px;
}

.km {
  font-size: 12px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #6f6f6f;
}

.goodsXq /deep/ img {
  width: 100%;
}

.ul {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-right: 20px;
}
.Box {
  column-count: 2;
  column-gap: 13px;
  column-width: auto;
  margin-top: 10px;
}

.Box::after {
  content: "";
  width: 45.5%;
  height: 0;
  visibility: hidden;
}

.li {
  width: 100%;
  background: #fff;
  border-radius: 8px;
  margin-bottom: 12px;
  overflow: hidden;
  box-sizing: border-box;
  page-break-inside: avoid;
  clear: both;
  /* display: inline-block; */
  position: relative;
}

.li img {
  border-radius: 8px 8px 0 0;
  width: 100%;
  height: auto;
  object-fit: cover;
  display: block;
}
.tit {
  font-size: 15px;
  font-family: PingFang SC;
  color: #333333;
  margin-bottom: 8px;
}
</style>
<style>
p {
  display: block;
  -webkit-margin-before: 0em;
  -webkit-margin-after: 0em;
  -webkit-margin-start: 0px;
  -webkit-margin-end: 0px;
}
</style>